import React from "react";
import { Eye, Sparkles, Flame } from "lucide-react";
import { cn } from "@/lib/utils";

interface SocialProofIndicatorProps {
  watcherCount?: number;
  recentPops?: number;
  isHeatingUp?: boolean;
  className?: string;
  compact?: boolean;
}

export const SocialProofIndicator: React.FC<SocialProofIndicatorProps> = ({
  watcherCount = 0,
  recentPops = 0,
  isHeatingUp = false,
  className,
  compact = false,
}) => {
  if (watcherCount === 0 && recentPops === 0 && !isHeatingUp) {
    return null;
  }

  if (compact) {
    return (
      <div className={cn("flex items-center gap-2 text-xs", className)}>
        {watcherCount > 0 && (
          <span className="flex items-center gap-0.5 text-muted-foreground">
            <Eye className="w-3 h-3" />
            {watcherCount}
          </span>
        )}
        {recentPops > 0 && (
          <span className="flex items-center gap-0.5 text-pop">
            <Sparkles className="w-3 h-3" />
            {recentPops}
          </span>
        )}
        {isHeatingUp && (
          <span className="flex items-center gap-0.5 text-orange-500">
            <Flame className="w-3 h-3 animate-pulse" />
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col gap-1 text-xs", className)}>
      {watcherCount > 0 && (
        <div className="flex items-center gap-1.5 text-muted-foreground">
          <Eye className="w-3.5 h-3.5" />
          <span>{watcherCount} people watching</span>
        </div>
      )}
      {recentPops > 0 && (
        <div className="flex items-center gap-1.5 text-pop animate-pulse">
          <Sparkles className="w-3.5 h-3.5" />
          <span>{recentPops} Pops in last 2 mins</span>
        </div>
      )}
      {isHeatingUp && (
        <div className="flex items-center gap-1.5 text-orange-500 font-medium animate-bounce">
          <Flame className="w-3.5 h-3.5" />
          <span>Arena is heating up! 🔥</span>
        </div>
      )}
    </div>
  );
};

export default SocialProofIndicator;
